
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/diary",
      function () {
        return require("private-next-pages/diary.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/diary"])
      });
    }
  